import { useCallback, useState } from "react";

const useToggleState = (initial: boolean) => {
	const [isToggled, setToggleState] = useState<boolean>(initial);

	const toggle = useCallback(() => setToggleState((prev) => !prev), []);
	const on = useCallback(() => setToggleState(true), []);
	const off = useCallback(() => setToggleState(false), []);

	return {
		toggle,
		on,
		off,
		isToggled,
	};
};

export default useToggleState;
export type UseToggleStateReturn = ReturnType<typeof useToggleState>;
